/**
 * Environment detection utilities
 * Provides functions to detect the current runtime environment
 */

/**
 * Check if the app is running on localhost
 * @returns true if running on localhost, 127.0.0.1, or 0.0.0.0
 */
export const isLocalhost = (): boolean => {
  if (typeof window === 'undefined') {
    return false
  }

  return (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1' ||
    window.location.hostname === '0.0.0.0'
  )
}

/**
 * Check if the app is running in development mode
 * @returns true if VITE_ENVIRONMENT is 'development'
 */
export const isDevelopment = (): boolean => {
  return import.meta.env.VITE_ENVIRONMENT === 'development'
}

/**
 * Check if the app is running in staging mode
 * @returns true if VITE_ENVIRONMENT is 'staging'
 */
export const isStaging = (): boolean => {
  return import.meta.env.VITE_ENVIRONMENT === 'staging'
}

/**
 * Check if the app is running in production mode
 * @returns true if VITE_ENVIRONMENT is 'production'
 */
export const isProduction = (): boolean => {
  return import.meta.env.VITE_ENVIRONMENT === 'production'
}

/**
 * Get the current environment name
 * @returns the current environment string
 */
export const getEnvironment = (): string => {
  return import.meta.env.VITE_ENVIRONMENT || 'development'
}

/**
 * Check if error reporting should be enabled
 * @returns true if error reporting should be enabled (not localhost and not development)
 */
export const shouldEnableErrorReporting = (): boolean => {
  return !isLocalhost() && !isDevelopment()
}
